import Model from '@/class/cargo/model/utils/Model'

export default class XhqIEPortConstants {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const FOREIGN_PORT_CUSTOMS = new XhqIEPortConstants('2225', 'Foreign Port Customs', '外港海关')
export const YANG_SHAN_PORT_AREA = new XhqIEPortConstants('2248', 'Yang shan Port Area', '洋山港区')
export const WU_SONG = new XhqIEPortConstants('2202', 'Wu Song', '吴淞')
export const XHQ_IE_PORT = [FOREIGN_PORT_CUSTOMS, YANG_SHAN_PORT_AREA, WU_SONG]

export function getXhqIEPortByName(code) {
  return Model.getObjByCode(code, XHQ_IE_PORT)
}
